<div class="loading-indicator">
  <div class="loading-indicator__track" *ngIf="show" [style.animation-duration]="speed"></div>
</div>
